import { i18n } from '@/i18n'
import { type ElementInfo, slotBaseName } from '@/lib/design/design-element'

/** The name the editor and the chat show for an element: its slot, free-element or part name, else its kind. */
export function elementDisplayName(info: ElementInfo): string {
  const t = (key: string): string => i18n.global.t(key) as string
  if (info.kind === 'slot' && info.slotName) {
    const key = `design.editor.slots.${slotBaseName(info.slotName)}`
    return i18n.global.te(key) ? t(key) : info.slotName
  }
  if (info.kind === 'free') return info.freeName ?? t('design.editor.parts.shape')
  if (info.partName) return info.partName
  if (info.type === 'image') return t('design.editor.parts.picture')
  return t(info.type === 'text' ? 'design.editor.parts.text' : 'design.editor.parts.shape')
}
